module.exports = __webpack_public_path__ + "static/logo-ffb532ebf743f75e4445482bc7c434a5.png";